// This is a blank page that gets rendered after redirect from the external Auth0 login page before the client Auth0 library initializes.

import React from "react";

const CallbackPage = () => {
  return <div></div>;
};

export default CallbackPage;
